import React from "react";
import "./GalleryHero.css";

const GalleryHero = () => {
  return (
    <section className="gallery-hero">
      <div className="gallery-hero-content">
        <h1>Our Gallery</h1>
        <p>
          A visual journey through our initiatives, events, and the impact we’ve
          created in communities together.
        </p>
      </div>
    </section>
  );
};

export default GalleryHero;
